import React from "react";

import { Table, Pagination, Typography } from "clearsense-ui/components";
import ContentBox from "components/Common/ContentBox";

import { QA_COLUMN, DATA_QA_PAGE_SIZE_OPTIONS_LIST } from "../../../constants";

const noop = () => {};

const DataTable = ({
  tableData = [],
  isLoading = true,
  page = 1,
  per = 10,
  setPage = noop,
  setPer = noop,
  totalRecordsCount = 0,
}) => (
  <div className="pr-8">
    <ContentBox className="data_qa_dashboard__table m-4">
      <Typography style="h4" type="semibold" className="my-2">
        CDE Data Table
      </Typography>
      <Table
        rowData={tableData}
        columnData={QA_COLUMN((Object.keys(tableData[0] ?? {}) ?? [])[0])}
        isLoading={isLoading}
      />
      <Pagination
        pageSize={per}
        setPageSize={setPer}
        currentPage={page}
        setCurrentPage={setPage}
        showResultsPerPage
        totalRecordsCount={totalRecordsCount}
        pageSizeOptionsList={DATA_QA_PAGE_SIZE_OPTIONS_LIST}
      />
    </ContentBox>
  </div>
);

export default DataTable;
